import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauthenticated, object = authenticated
  const [walletAddress, setWalletAddress] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data.wallet_address) setWalletAddress(data.wallet_address);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("cure8r_token", data.token);
    setUser(data.user);
    if (data.user.wallet_address) setWalletAddress(data.user.wallet_address);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("cure8r_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("cure8r_token");
    setUser(false);
    setWalletAddress(null);
  };

  const connectWallet = async () => {
    const { data } = await api.post("/wallet/connect");
    setWalletAddress(data.wallet_address);
    setUser((u) => (u ? { ...u, wallet_address: data.wallet_address } : u));
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh, walletAddress, connectWallet }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
